export const PHOTO_TATTOO = "tattoo"
export const PHOTO_FLASH = "flash"
export const PHOTO_COLLECTION = "collection"

export const PHOTO_TYPES = [PHOTO_TATTOO, PHOTO_FLASH, PHOTO_COLLECTION]
